import { styled } from '@mui/material/styles';
import { Box, Card, Button } from '@mui/material';
import { colors } from '../../../../styles/theme/colors';

export const StyledDialog = {
  PaperProps: {
    sx: {
      borderRadius: 3,
      overflow: 'hidden',
      boxShadow: '0 20px 60px rgba(2, 6, 23, 0.18)',
    },
  },
};

export const HeaderBox = styled(Box)(({ theme }) => ({
  padding: '18px 24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: '#ffffff',
  color: '#111827',
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
}));

export const HeaderIconBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: '8px',
  width: 32,
  height: 32,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const DashboardCardBlue = styled(Card)({
  borderRadius: 12,
  background: 'linear-gradient(180deg, rgba(59,130,246,0.06) 0%, rgba(59,130,246,0.03) 100%)',
  borderColor: 'rgba(59,130,246,0.30)',
});

export const DashboardCardGreen = styled(Card)({
  borderRadius: 12,
  background: 'linear-gradient(180deg, rgba(16,185,129,0.06) 0%, rgba(16,185,129,0.03) 100%)',
  borderColor: 'rgba(16,185,129,0.30)',
});

export const DashboardCardRed = styled(Card)({
  borderRadius: 12,
  background: 'linear-gradient(180deg, rgba(239,68,68,0.06) 0%, rgba(239,68,68,0.03) 100%)',
  borderColor: 'rgba(239,68,68,0.30)',
});

export const DashboardIconBoxBlue = styled(Box)({
  backgroundColor: 'rgba(59,130,246,0.16)',
  color: '#2563eb',
  width: 36,
  height: 36,
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const DashboardIconBoxGreen = styled(Box)({
  backgroundColor: 'rgba(16,185,129,0.16)',
  color: '#10b981',
  width: 36,
  height: 36,
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const DashboardIconBoxRed = styled(Box)({
  backgroundColor: 'rgba(239,68,68,0.16)',
  color: '#ef4444',
  width: 36,
  height: 36,
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const SectionBox = styled(Box)(({ theme }) => ({
  border: '1px solid rgba(6,182,212,0.25)',
  borderRadius: theme.spacing(2),
  overflow: 'hidden',
}));

export const SectionHeader = styled(Box)({
  padding: '10px 16px',
  background: 'linear-gradient(90deg, rgba(6,182,212,0.10) 0%, rgba(6,182,212,0.04) 100%)',
  borderBottom: '1px solid rgba(6,182,212,0.25)',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const PaymentStatusBox = styled(Box)(({ theme }) => ({
  border: '1px solid rgba(16,185,129,0.25)',
  borderRadius: theme.spacing(2),
  overflow: 'hidden',
  marginBottom: theme.spacing(3),
}));

export const PaymentStatusHeader = styled(Box)({
  padding: '10px 16px',
  background: 'linear-gradient(90deg, rgba(16,185,129,0.10) 0%, rgba(16,185,129,0.04) 100%)',
  borderBottom: '1px solid rgba(16,185,129,0.25)',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const PaymentMethodButton = styled(Button)({
  paddingTop: 6,
  paddingBottom: 6,
  minWidth: 0,
});

// Botón Cancelar/Atrás según diseño del sistema (gris, sin azul)
// Color/fondo/hover vienen de variant="tonal" del tema; aquí solo tamaño/spacing.
export const CancelButton = styled(Button)(({ theme }) => ({
  '&&': {
    minWidth: '120px',
    padding: '9px 18px',
    borderRadius: '10px',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '0.875rem',
  },
  '&&:disabled': {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
  },
}));

// Degradado cyan-verde del sistema (evitar azul primary)
const systemGradient = `linear-gradient(to right, ${colors.info.main}, ${colors.success.main})`;
const systemGradientHover = `linear-gradient(to right, ${colors.info.dark}, ${colors.success.dark})`;

export const ProcessButton = styled(Button)(({ theme }) => ({
  '&&': {
    background: systemGradient,
    backgroundColor: 'transparent',
    color: '#ffffff',
  },
  '&&:hover': {
    background: systemGradientHover,
    backgroundColor: 'transparent',
  },
  '&&:disabled': {
    backgroundColor: theme.palette.action.disabledBackground,
    background: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
  },
}));

// Botón de acción principal para diálogos internos (Agregar, Guardar)
export const PrimaryActionButton = styled(Button)(({ theme }) => ({
  '&&': {
    background: systemGradient,
    backgroundColor: 'transparent',
    color: '#ffffff',
  },
  '&&:hover': {
    background: systemGradientHover,
    backgroundColor: 'transparent',
  },
  '&&:disabled': {
    backgroundColor: theme.palette.action.disabledBackground,
    background: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
  },
}));
